module.exports = __webpack_public_path__ + "static/img/03.e5171baf.png";